import { useState, useId, ReactNode, FC } from 'react'; // FCをインポート

type ChevronIconProps = {
  open: boolean;
};

const ChevronIcon: FC<ChevronIconProps> = ({ open }) => (
  <svg
    viewBox="0 0 12 12"
    className={`
      size-3 shrink-0 transition-transform
      ${open ? 'rotate-90' : ''}
    `}
    aria-hidden="true"
  >
    <path d="M4 2l4 4-4 4" fill="currentColor" stroke="currentColor" strokeWidth="1" />
  </svg>
);

type P_CollapsibleSectionProps = {
  title: ReactNode;
  defaultOpen?: boolean;
  canToggle?: boolean;
  rightSlot?: ReactNode;
  className?: string;
  accentClassName?: string;
  contentClassName?: string;
  onToggle?: (open: boolean) => void;
  children: ReactNode;
};

const P_CollapsibleSection: React.FC<P_CollapsibleSectionProps> = ({
  title,
  defaultOpen = true,
  canToggle = true,
  rightSlot,
  className = '',
  accentClassName = 'border-blue-600',
  contentClassName = '',
  onToggle,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const contentId = useId();
  return (
    <section className={`w-full ${className}`}>
      <div className={`border-t-2 ${accentClassName} mb-1`} />
      <div className="flex w-full items-center gap-2 text-lg font-semibold text-slate-800">
        {canToggle ? (
          <button
            type="button"
            className="flex flex-1 items-center gap-2 text-left"
            aria-expanded={open}
            aria-controls={contentId}
            onClick={() => {
              const next = !open;
              setOpen(next);
              onToggle?.(next);
            }}
          >
            <ChevronIcon open={open} />
            <span>{title}</span>
          </button>
        ) : (
          <span>{title}</span>
        )}
        <span className="ml-auto">{rightSlot}</span>
      </div>
      <div
        id={contentId}
        className={`
          grid transition-[grid-template-rows] duration-300 ease-in-out
          ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}
        `}
      >
        <div className="overflow-hidden">
          <div className={['mt-2', contentClassName].join(' ')}>{children}</div>
        </div>
      </div>
    </section>
  );
};

export default P_CollapsibleSection;
